module.exports = __webpack_public_path__ + "static/media/marker-green.153c7e08.svg";